export { base64StringFromByteArray } from './fromByteArray';
//# sourceMappingURL=index.js.map